module.exports = __webpack_public_path__ + "static/img/qrcode1.1572cca8.png";